import React, { useState } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { useNavigate, Routes, Route } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import Sidebar from './Sidebar';
import HomeTab from './HomeTab';
import SubscriptionTab from './subscription/SubscriptionTab';
import SupportTicketsTab from './SupportTicketsTab';
import MyAccountTab from './MyAccountTab';
import MyInvoicesTab from './MyInvoicesTab';
import ChangePasswordTab from './ChangePasswordTab';
import MyPlan from './MyPlan';
import './Dashboard.css';

const Dashboard = () => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const toggleMobileMenu = () => {
    setShowMobileMenu(!showMobileMenu);
  };

  const handleLogout = () => {
    // Add your logout logic here
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <div className="dashboard-container">
      {/* Mobile Menu Button */}
      <Button 
        variant="dark" 
        className="mobile-menu-btn d-md-none"
        onClick={toggleMobileMenu}
      >
        <FaBars />
      </Button>

      <Row className="h-100 g-0">
        <Col className={`sidebar-col p-0 ${showMobileMenu ? 'show' : ''}`} style={{ width: isCollapsed ? '60px' : '250px' }}>
          <Sidebar 
            isCollapsed={isCollapsed}
            toggleSidebar={toggleSidebar}
            onLogout={handleLogout}
          />
        </Col>
        <Col className={`content-col ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
          <div className="content-wrapper">
            <Routes>
              <Route path="/" element={<HomeTab />} />
              <Route path="/subscription" element={<SubscriptionTab />} />
              <Route path="/my-plan" element={<MyPlan />} />
              <Route path="/support-tickets" element={<SupportTicketsTab />} />
              <Route path="/my-account" element={<MyAccountTab />} />
              <Route path="/my-invoices" element={<MyInvoicesTab />} />
              <Route path="/change-password" element={<ChangePasswordTab />} />
            </Routes>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard; 